<template>
  <div class="toogle-price-list" :class="{ opened: opened }">
    <!-- Title -->
    <div class="price-list-title" @click="opened = !opened">
      <div class="title-holder relative">
        <Icon class="absolute circled-icon" v-show="!opened"
          name="arrowRight"
          size="20" />
        <Icon class="absolute circled-icon" v-show="opened"
          name="arrowDown"
          size="20" />
        <span>{{ name }}</span>
      </div>
      <span class="d-block">{{ colli.total_colli_price | currency }}</span>
    </div>
    <!-- Body -->
    <div class="price-list" v-if="opened">
      <div v-for="(priceItem, index) in colli.colli_prices[0]" :key="`price-${index}`">
        <span>{{ priceItem.name }}</span>
        <span v-if="priceItem.sales_price != null">{{ priceItem.sales_price | currency }}</span>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'PriceCard',
  props: {
    currency: {
      type: String,
    },
    name: {
      type: String,
      default: '',
    },
    colli: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return{
      opened: false,
    };
  }
}
</script>
